'use client';

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const ConversationContext = /*#__PURE__*/React.createContext({
  conversationId: undefined,
  hasConversation: false,
  conversation: null
});
if (process.env.NODE_ENV !== "production") ConversationContext.displayName = "ConversationContext";
export function ConversationContextProvider(props) {
  const {
    children,
    value
  } = props;
  return /*#__PURE__*/_jsx(ConversationContext.Provider, {
    value: value,
    children: children
  });
}
export function useConversationContext() {
  return React.useContext(ConversationContext);
}